import isNumber from 'lodash/isNumber';
import { post } from '../../../../../shared/utils/http';

import { initialiseCommonStore } from '../../../../../shared/components/react/CommonDataStore/actions';
import { COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS } from '../../../../../shared/components/react/CommonDataStore/actionTypes';
import mainSocket from '../../../../../shared/services/mainSocketClass';

import { getSelectionOrderingForInplayStart } from '../utils/utils';
import { updateMetaData } from '../../../../../shared/components/react/MetaDataStore/actions';
import { buildSpectateUrl } from '../../../../../spa/Utils/Spectate';
import {
    COMMON_DATA_LIST_EVENTS_ERROR,
    COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS,
    COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES,
    COMMON_DATA_LIST_EVENTS_STOP_LISTENING_FOR_WS_UPDATES,
} from '../actions/commonDataListEventsActionsTypes';
import { eventIsOver } from '../../../sport-event/utils';

export const commonDataListEventsErrorOccurred = bool => {
    return {
        type: COMMON_DATA_LIST_EVENTS_ERROR,
        errorOccurred: bool,
    };
};

export const getWidgetEvents = (wsEventListener, postURL, postParams, postOptions, dispatchAction = false) => {

    return async (dispatch) => {
        try {

            const response = await post(
                buildSpectateUrl(postURL),
                postParams,
                postOptions
            );
            if (!response.ok) {
                dispatch(commonDataListEventsErrorOccurred(true));

                return Object.getPrototypeOf(Function);
            }

            const data = await response.json();
            /**
             * Temporary solution to PP -> IP transition bug for 3 market view
             * @todo https://dedsert.atlassian.net/browse/AM-4687
             */
            const { sport_slug: sportSlug = '' } = [Object.values(data.events)];
            dispatch([
                updateMetaData({
                    matchRequestLimit: data.match_request_limit,
                    marketMenus: data.market_menus,
                }),
                initialiseCommonStore(data.events),
                startListeningForWsUpdates(data.selection_pointers),
                widgetEvents(data.event_order),
            ]);
            if (data.selection_pointers.length) {
                return mainSocket.onWsEventUpdate(async (wsData) => {
                    const { events, action } = wsData;
                    if (action === 'event_off') {
                        /**
                         * Tricky - do we unsubscribe? If we do then we will not get an inplay_start message
                         * (if a corresponding inplay event is booked). If we don't we remain subscribed to
                         * an event that may never go inplay. I'm going with don't unsubscribe and leaving
                         * this here as a hint to future readers. We should unsubscribe from the off'd event
                         * when the component unmounts anyway.
                         */
                        // dispatch(stopListeningForUpdates(events));
                    }

                    if (action === 'inplay_update'){
                        const endedEvents = events.filter(event => !isNumber(event) && eventIsOver(event.match_status));
                        if (endedEvents.length) {
                            dispatch(stopListeningForUpdates(endedEvents));
                        }
                    }

                    // @todo AM-4687
                    if (action === 'inplay_start' && sportSlug === 'football') {
                        // reorder the selections in the websocket message
                        // eslint-disable-next-line no-param-reassign
                        wsData = await getSelectionOrderingForInplayStart(wsData);
                    }

                    if (dispatchAction) {
                        dispatch(wsEventListener(wsData));
                    } else {
                        wsEventListener(wsData);
                    }
                });
            }
        } catch (e) {
            dispatch(commonDataListEventsErrorOccurred(true));
        }

        return Object.getPrototypeOf(Function);
    };
};

export const widgetEvents = (events) => {
    return {
        type: COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS,
        events,
    };
};

export const startListeningForWsUpdates = (selectionPointers = []) => {
    return {
        type: COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES,
        selectionPointers,
    };
};

export const stopListeningForUpdates = (events) => {
    return {
        type: COMMON_DATA_LIST_EVENTS_STOP_LISTENING_FOR_WS_UPDATES,
        events,
    };
};

export const updateCommonStoreWsData = wsData => {
    return {
        type: COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS,
        wsData: wsData,
    };
};
